var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFusdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105px",
    height: "121px",
    viewBox: "0 0 105 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uA730USDt (Tether)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "40.2650239 0 80.5301187 23.2469773 80.5301187 69.7408966 40.2650239 92.9877322 0 69.7408966 0 23.2469773"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uA730Tokens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uA730USDt-(Tether)",
    transform: "translate(0.797678, 0.163865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.347232,31.4871635 L51.9614278,2.97433393 L2.57584899,31.487167 L2.57584899,88.5129442 L51.9614278,117.025669 L101.347232,88.5129476 L101.347232,31.4871635 Z M51.9598795,8.92022235 L96.193186,34.4600072 L96.193186,85.5360352 L51.9598795,111.07582 L7.72657297,85.5360352 L7.72657297,34.4600072 L51.9598795,8.92022235 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.923081,30 L51.9614247,0 L0,30 L0,90.0001126 L51.9614247,120 L103.923081,90.0001196 L103.923081,30 Z M51.9614308,5.94866785 L98.7713832,32.9743327 L98.7713832,87.0257757 L51.9614308,114.051338 L5.15169797,87.0257757 L5.15169797,32.9743327 L51.9614308,5.94866785 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(11.697080, 13.507835)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-4)",
    fill: "#F2F2F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.675983, -2.447105)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9410422,97.8819427 C75.9705003,97.8819427 97.8820844,75.9703586 97.8820844,48.9409005 C97.8820844,21.9116195 75.9705003,0 48.9410422,0 C21.9116195,0 0,21.9116195 0,48.9409005 C0,75.9703586 21.9116195,97.8819427 48.9410422,97.8819427 Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M75.3903141,38.0017011 L75.3903141,46.5100171 L57.8017596,46.5100171 L57.8017596,52.409132 C70.1547186,53.0395287 79.4228134,55.6287205 79.4915838,58.7321375 L79.4915838,65.2017173 C79.4224248,68.3051344 70.1547186,70.8942289 57.8017596,71.5246256 L57.8017596,86.0017011 L46.122616,86.0017011 L46.122616,71.5246256 C33.7695597,70.8942289 24.501465,68.3051344 24.4326944,65.2017173 L24.4326944,58.7321375 C24.5018535,55.6287205 33.7695597,53.0395287 46.122616,52.409132 L46.122616,46.5100171 L28.5339643,46.5100171 L28.5339643,38.0017011 L75.3903141,38.0017011 Z M51.9621878,67.0799887 C65.1450558,67.0799887 76.1637886,64.8905987 78.8603129,61.9668786 C76.573595,59.487545 68.3023817,57.5363263 57.8017596,57.0004404 L57.8017596,63.1767744 C55.9196027,63.2728394 53.9658586,63.323446 51.9621878,63.323446 C49.9584196,63.323446 48.0046756,63.2728394 46.122616,63.1767744 L46.122616,57.0004404 C35.6218965,57.5363263 27.3506834,59.487545 25.0639654,61.9668786 C27.7605869,64.8905987 38.7792224,67.0799887 51.9621878,67.0799887 Z",
    id: "Shape",
    fill: "#505050"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusdt);
export default __webpack_public_path__ + "static/media/fusdt.b02724ff912cfa10803e0d3c0d188e1a.svg";
export { ForwardRef as ReactComponent };